interface Props {
  metadata: {
    title: string
    description: string
  }[]
}

function CaseStudyMetaDetails({ metadata }: Props) {
  return (
    <section className="bg-[#1F2179] py-6 text-white">
      <div className="container | flex flex-wrap gap-y-4">
        {metadata.map(post => (
          <div
            key={post.title}
            className="min-w-[46%] flex-1 px-5 first:pl-0 md:min-w-40 md:border-l md:border-white/15 md:px-7 md:first:border-l-0"
          >
            <span className="mb-1 block text-[11px] font-bold uppercase tracking-[0.12em] text-[#9FB4FF]">
              {post.title}
            </span>
            <span className="block text-[17px] font-bold">
              {post.description}
            </span>
          </div>
        ))}
      </div>
    </section>
  )
}

export default CaseStudyMetaDetails
